module.exports = __webpack_public_path__ + "static/media/game(14).6980c1c1.PNG";